import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import HtmlContent from './HtmlContent';

let instance = null;

export default class Experience {
    constructor(container, filtersArrays) {
        if (instance) return instance;
        instance = this;
        window.experience = this;

        this.container = container;
        this.filtersArrays = filtersArrays
        this.container.style.height = `${(this.container.offsetWidth / 16) * 9}px`;
        // !Editer les filtres 
        // !Editer les filtres 
        // !Editer les filtres 
        // !Editer les filtres 
        // !Editer les filtres 
        // !dossier 1 
        this.allPathologiesArray = this.filtersArrays[0]
        // !dossier 2
        this.allCountriesArray = this.filtersArrays[1]
        // !dossier 3
        this.allExpertisesArray = this.filtersArrays[2]
        // !Editer les filtres 
        // !Editer les filtres 
        // !Editer les filtres 
        // !Editer les filtres 
        // !Editer les filtres 

        this.markers = [];
        // Initialisation des filtres sous forme d'ensembles pour chaque catégorie
        this.filters = {
            allPathologies: new Set(),
            allCountries: new Set(),
            allExpertises: new Set()
        };


        this.fetchData().then((data) => {
            this.data = data;
            // create individual indexs : 
            this.data.features.forEach((feature, i) => {
                feature.properties.id = i


            })
            this.setMap();

            // Création des filtres une fois la data chargée
            this.setFilters();
        }).catch((error) => {
            console.error(error);
        });

        window.addEventListener('resize', () => this.resize());
    }

    async fetchData() {
        try {
            const response = await fetch('/cure51/mapData.geojson');
            if (!response.ok) throw new Error('Network response was not ok');
            return await response.json();
        } catch (error) {
            throw new Error('Failed to fetch data: ' + error.message);
        }
    }

    setMap() {
        this.map = new maplibregl.Map({
            container: 'map',
            style: './mapStyle.json',
            center: [0, 50],
            zoom: 0.5, // Zoom initial réduit pour l'animation
            minZoom: 1.5,
            attributionControl: false
        });

        this.map.on('load', () => {
            this.htmlContent = new HtmlContent()
            this.addSourcesAndLayers();
            this.addControls();
            this.map.on('moveend', this.getActiveData.bind(this));
            this.map.on('zoomend', this.getActiveData.bind(this));
            setTimeout(() => {
                this.map.fire('moveend')

            }, 1000)

            this.update();
        });
        // display coordinates on click
        this.map.on('click', (e) => {
            const coordinates = `[${e.lngLat.lng}, ${e.lngLat.lat}]`
            console.log(coordinates);
        })
    }

    addSourcesAndLayers() {
        const filteredData = {
            type: 'FeatureCollection',
            features: this.data.features.filter(feature => feature.properties.display === true)
        };
        this.map.addSource('pointData', {
            type: 'geojson',
            data: filteredData,
            cluster: true,
            clusterMaxZoom: 14,
            clusterRadius: 50
        });

        this.map.addLayer({
            id: 'poiClusters',
            type: 'circle',
            source: 'pointData',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': '#000',
                'circle-radius': [
                    'step', ['get', 'point_count'],
                    20, 100,
                    30, 750,
                    40
                ]
            },
            minzoom: 0,
            maxzoom: 14
        });

        this.map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'pointData',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': '{point_count_abbreviated}',
                'text-size': 14
            },
            paint: {
                'text-color': '#fff'
            }
        });

        this.map.addLayer({
            id: 'poi',
            type: 'circle',
            source: 'pointData',
            filter: ['!', ['has', 'point_count']],
            paint: {
                'circle-color': '#ff0000',
                'circle-radius': 10,
                'circle-opacity': 0 // Opacité à 0 pour nos markers personnalisés
            },
            minzoom: 0,
            maxzoom: 21
        });
        // click on cluster
        this.map.on('click', 'poiClusters', (e) => {
            const features = this.map.queryRenderedFeatures(e.point, { layers: ['poiClusters'] });
            if (!features.length) return;
            const clusterId = features[0].properties.cluster_id;
            const source = this.map.getSource('pointData');

            const expansionZoom = source.getClusterExpansionZoom(clusterId).then((res) => {
                this.map.easeTo({
                    center: features[0].geometry.coordinates,
                    zoom: res,  // Zoomer légèrement plus que la valeur retournée
                    essential: true
                });
            })





        });

    }
    getMarker(id) {
        // Cherche le marker avec l'id correspondant dans le tableau markers
        const markerData = this.markers.find(marker => marker.id === id);

        if (markerData) {
            return markerData.marker; // Retourne le marker si trouvé
        } else {
            console.error(`Marker with ID ${id} not found`);
            return null; // Retourne null si aucun marker n'est trouvé
        }
    }


    createMarker(coordinates, data, id) {
        const markerElement = document.createElement('div');
        markerElement.className = 'custom-marker';
        const rand = Math.random() * 2;
        markerElement.innerHTML = `
        <div class="container">
          <div class="point" style="animation-delay: ${rand}s;"></div>
          <div class="anneau1" style="animation-delay: ${rand}s;"></div>
          <div class="anneau2" style="animation-delay: ${rand + 0.3}s;"></div>
        </div>`;

        const marker = new maplibregl.Marker({ element: markerElement })
            .setLngLat(coordinates)
            .setOpacity(0)
            .addTo(this.map);

        markerElement.addEventListener('click', () => {
            this.markers.forEach((marker) => {
                const element = marker.marker.getElement()

                if (element !== markerElement) {

                    const container = element.children[0];
                    container.style.scale = '1'; // réinitialiser la taille
                    container.style.setProperty('--beforeWidth', '0px');

                    container.children[0].style.backgroundColor = '#ff792c'; // réinitialiser la couleur
                    container.children[1].style.borderColor = '#ff792c'; // réinitialiser la couleur du bord
                    container.children[2].style.borderColor = '#ff792c'; // réinitialiser la couleur du bord
                }
            });
            markerElement.children[0].style.scale = '2'
            markerElement.children[0].style.setProperty('--beforeWidth', `${window.innerWidth}px`);
            markerElement.children[0].style.setProperty('--beforeColor', '#4F0FFF');

            markerElement.children[0].children[0].style.backgroundColor = '#4F0FFF'
            markerElement.children[0].children[1].style.borderColor = '#4F0FFF'
            markerElement.children[0].children[2].style.borderColor = '#4F0FFF'



            // Obtenez les coordonnées du marker
            const lat = marker.getLngLat().lat;
            const lon = marker.getLngLat().lng;

            // Centrer la carte sur le marker
            this.map.flyTo({
                center: [lon + 0.1, lat],  // Les coordonnées du marker
                essential: true,
                zoom: 8,             // Niveau de zoom que vous souhaitez
            });

            this.htmlContent.setArticle(data)
        });


        // Stockage des données pour le filtrage ultérieur
        this.markers.push({ marker, coordinates, id, data });
    }

    /**
     * Met à jour la visibilité des markers en fonction de leur présence sur la carte
     * et des filtres sélectionnés.
     */
    updateMarkersVisibility() {
        // Obtenir les POIs visibles (hors clusters)
        const visibleFeatures = this.map.queryRenderedFeatures({ layers: ['poi'] });
        const visibleFeatureIds = new Set(visibleFeatures.map(f => f.properties.id));

        // Création de marqueurs pour les nouvelles entités visibles
        this.data.features.forEach(feature => {
            const id = feature.properties.id;

            const coordinates = feature.geometry.coordinates;
            const data = feature;
            // Assurer que data.tags est défini
            data.tags = feature.properties.tags || {};


            const existingMarker = this.markers.find((m) => m.id === id);
            if (!existingMarker) {
                this.createMarker(coordinates, data, id);
            }
        });

        // Gérer la visibilité des marqueurs existants
        this.markers.forEach(({ marker, id }) => {
            // Vérifier si l'ID de l'entité est visible
            if (visibleFeatureIds.has(id)) {
                marker.setOpacity(1);
                marker._element.style.pointerEvents = 'auto'; // Réactiver les événements
            } else {
                marker.setOpacity(0);
                marker._element.style.pointerEvents = 'none'; // Désactiver les événements
            }
        });
    }
    getActiveData() {
        const visibleFeatures = this.map.queryRenderedFeatures({ layers: ['poi'] });
        const visibleClusterFeatures = this.map.queryRenderedFeatures({ layers: ['poiClusters'] });
        const groupedData = [];

        visibleFeatures.forEach(feature => {
            groupedData.push({
                id: feature.properties.id,
                geometry: feature.geometry,
                properties: feature.properties
            });
        });

        const addClusterChildren = async (clusterId, zoom) => {
            try {
                const expansionZoom = await this.map.getSource('pointData').getClusterExpansionZoom(clusterId);
                if (zoom <= expansionZoom) {
                    const children = await this.map.getSource('pointData').getClusterChildren(clusterId);
                    for (const child of children) {
                        if (child.properties.cluster) {
                            await addClusterChildren(child.properties.cluster_id, zoom);
                        } else {
                            groupedData.push({
                                id: child.properties.id,
                                geometry: child.geometry,
                                properties: child.properties
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des enfants du cluster:', error);
            }
        };

        const clusterPromises = visibleClusterFeatures.map(cluster => {
            const clusterId = cluster.properties.cluster_id;
            const currentZoom = this.map.getZoom();
            return addClusterChildren(clusterId, currentZoom);
        });

        Promise.all(clusterPromises).then(() => {
            this.visibleData = groupedData;

            // ? update here the HTML content
            this.htmlContent.setData(this.visibleData)
            this.htmlContent.update(this.visibleData)

        });
    }

    addControls() {
        this.map.addControl(new maplibregl.NavigationControl(), 'bottom-left');
    }

    /**
     * Crée l'interface des filtres.
     * Ici nous créons trois dropdowns basés sur le modèle :
     * - "All Pathologies" avec ['Nature', 'Culture', 'Urban']
     * - "All Countries" avec ['Museum', 'Park', 'Monument']
     * - "All Expertises" avec ['Europe', 'Asia', 'America']
     */
    setFilters() {
        this.filterContainer = document.createElement('div');
        this.filterContainer.style.position = 'absolute';
        this.filterContainer.style.top = '10rem';
        this.filterContainer.style.left = '10rem';
        this.filterContainer.style.display = 'flex';
        this.filterContainer.style.gap = '10rem';
        this.filterContainer.style.zIndex = '10';
        this.container.appendChild(this.filterContainer);

        // Création des dropdowns avec les libellés et clés adaptés
        this.createFilterDropdown('All Pathologies', 'allPathologies', this.allPathologiesArray);
        this.createFilterDropdown('All Countries', 'allCountries', this.allCountriesArray);
        this.createFilterDropdown('All Expertises', 'allExpertises', this.allExpertisesArray);
    }
    applyFilters() {
        const filterConditions = Object.values(this.filters).filter(set => set.size > 0);

        // Si aucun filtre n'est actif, réinitialise la source à son état initial
        if (filterConditions.length === 0) {
            this.map.setFilter('poi', ['!', ['has', 'point_count']]);
            this.map.setFilter('cluster-count', ['has', 'point_count']);

            // Réinitialise les données de la source pointData sans filtre
            const filteredData = {
                type: 'FeatureCollection',
                features: this.data.features.filter(feature => feature.properties.display === true)
            };
            this.map.getSource('pointData').setData(filteredData);
            return;
        }

        // Construire un tableau de filtres cumulés
        const cumulativeFilters = ['all', ...filterConditions.map(set => [
            'all', ...[...set].map(value => ['in', value, ['get', 'tags']])
        ])];

        // Applique les filtres aux layers de la carte
        this.map.setFilter('poi', cumulativeFilters);
        // this.map.setFilter('poiClusters', cumulativeFilters);
        // this.map.setFilter('cluster-count', cumulativeFilters);

        // Applique les filtres aux données GeoJSON pour la source pointData
        const filteredData = {
            type: 'FeatureCollection',
            features: this.data.features.filter(feature => {
                const tags = feature.properties.tags || [];
                const displayCondition = feature.properties.display === true; // Vérifie si display est true
                // Vérifie si le feature satisfait toutes les conditions du filtre et si display est true
                return filterConditions.every(set => [...set].every(tag => tags.includes(tag))) && displayCondition;
            })
        };


        // Mets à jour la source pointData avec les données filtrées
        const pointDataSource = this.map.getSource('pointData');
        if (pointDataSource) {
            pointDataSource.setData(filteredData);
        } else {
            console.error('Source "pointData" not found.');
        }

        // Mets à jour les markers (si vous en avez)
        this.markers.forEach(({ marker, data }) => {
            const tags = data.tags || [];
            const isVisible = filterConditions.every(set => [...set].every(tag => tags.includes(tag)));
            marker.setOpacity(isVisible ? 1 : 0);
        });

    }


    /**
     * Crée un dropdown composé d'un bouton et d'une liste d'options avec des cases à cocher.
     * Lorsqu'une option est cochée ou décochée, le Set correspondant dans this.filters est mis à jour
     * et la méthode applyFilters() est appelée pour appliquer les filtres aux POIs.
     */
    createFilterDropdown(label, filterKey, options) {
        const container = document.createElement('div');
        container.style.position = 'relative';

        const button = document.createElement('button');
        button.textContent = label;
        button.style.cursor = 'pointer';
        button.style.padding = '0.5rem 1rem';
        button.style.fontSize = '12rem';

        const dropdown = document.createElement('div');
        dropdown.style.position = 'absolute';
        dropdown.style.top = '100%';
        dropdown.style.left = '0';
        dropdown.style.background = 'white';
        dropdown.style.border = '1px solid black';
        dropdown.style.display = 'none';
        dropdown.style.padding = '0.5rem';

        // Création des options sous forme de checkbox
        options.forEach(option => {
            const item = document.createElement('label');
            item.style.display = 'block';
            item.style.padding = '0.25rem 0';

            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.value = option;
            checkbox.style.marginRight = '0.5rem';

            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    this.filters[filterKey].add(option);
                } else {
                    this.filters[filterKey].delete(option);
                }
                // Appliquer les filtres sur l'ensemble des markers
                this.applyFilters();
                // léger timeout pour etre sur que la data est bien chargée.
                setTimeout(() => {
                    this.map.fire('moveend')
                }, 100)

            });

            item.appendChild(checkbox);
            item.appendChild(document.createTextNode(option));
            dropdown.appendChild(item);
        });

        // Afficher/Masquer le dropdown au clic sur le bouton
        button.addEventListener('click', () => {
            dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
        });

        container.appendChild(button);
        container.appendChild(dropdown);
        this.filterContainer.appendChild(container);
    }


    resize() {
        this.container.style.height = `${(this.container.offsetWidth / 16) * 9}px`;
    }

    update() {
        this.updateMarkersVisibility();
        window.requestAnimationFrame(() => this.update());
    }
}
